import React, { useEffect, useState } from "react";
import badgesBg from "assets/images/others/host-side-images/badgesBg.png";
import { siteRoutes } from "utils/helpers/enums/routes";
import RsvpBreadcrumb, {
  RsvpBreadcrumbLink,
} from "components/breadcrumbs/RsvpBreadcrumb";
import useRsvp from "../useHooks";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { useSelector } from "react-redux";
import Pagination from "components/pagination";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import badgesNotFoundGif from "assets/images/gifs/badge-not-found.gif";

const RsvpMyBadges: React.FC = () => {
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const breadcrumbLinks: RsvpBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.rsvpHome },
    { title: "My Badges", path: siteRoutes.rsvpMyBadges },
  ];
  const [data, setData] = useState<any>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const [filters, setFilters] = useState({
    page: 0,
    size: 10,
    totalElements: 0,
  });

  // Fetching Badges
  const { getMyBadges } = useRsvp();
  // useEffect(() => {
  //   const payload = {
  //     badgeType: BAGDE_TYPES.EVENT
  //   }
  //   getMyBadges(setData, payload);
  // }, []);

  const loadBadges = (page = 0, size = 10) => {
    const queryParams: any = {
      page,
      size,
      badgeType: BAGDE_TYPES.EVENT,
    };

    getMyBadges(setData, queryParams, (totalElements: number) => {
      setFilters((prev) => ({
        ...prev,
        totalElements,
      }));
    });

    // Mark initial load as complete after first API call
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  };

  const handlePageChange = ({
    selected,
    limit,
  }: {
    selected: number;
    limit: number;
  }) => {
    setFilters({
      ...filters,
      page: selected,
      size: limit,
    });
    loadBadges(selected, limit);
  };

  useEffect(() => {
    // Reset pagination when tab changes
    setFilters({
      page: 0,
      size: 10,
      totalElements: 0,
    });
    loadBadges(0, 10);
  }, []);

  // Mark initial load as complete when loading finishes
  useEffect(() => {
    if (isInitialLoad && !isLoading) {
      setIsInitialLoad(false);
    }
  }, [isLoading, isInitialLoad]);

  return (
    <div className="container min-h-[70vh]">
      <RsvpBreadcrumb links={breadcrumbLinks} />
      <h2 className="text-2xl font-bold mb-4 text-blackie">My Badges</h2>
      <div className="flex flex-wrap gap-4 py-5">
        {data?.map((badge: any) => (
          <div
            key={badge.id}
            className="flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px]"
            style={{ backgroundImage: `url(${badgesBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                src={concatPathWithBackendUrl(badge?.image?.name)}
                alt="badge"
              />
            </div>
            <span className="text-sm font-medium mt-2 text-blackie">
              {badge.name}
            </span>
          </div>
        ))}
      </div>
      <div className="flex  justify-center">
        <CustomMessageDisplay
          show={!isLoading && !data.length && !isInitialLoad}
          title="No Badges Available"
          slogan={"You haven't earned any event badges yet."}
          image={badgesNotFoundGif}
          imageAlt="No badges found"
          className="py-12"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>

      {data.length > 0 && filters.totalElements > filters.size && (
        <Pagination
          count={filters.totalElements}
          page={filters.page}
          limit={filters.size}
          onPageChange={handlePageChange}
          activeBgColor={"#DE9C27"}
          activeTextColor={"#ffffff"}
        />
      )}
    </div>
  );
};

export default RsvpMyBadges;
